/*
 * @Descripttion: 处理有关消息的数据改变   当收到即时通讯消息是会到这里处理状态逻辑
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-06 14:46:42
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-03-09 14:55:58
 */
import actionTypes from '../actionTypes'
import { fromJS } from 'immutable'
// import { savemessageList } from '../../service/localstore'

const defaultState = fromJS({ // 将对象转成immutable对象
  messageList: fromJS({}),
  onlineServiceList: fromJS([]),
  onlineServiceId: fromJS('智能客服'),
})

export default (state = defaultState, action) => {
  let newstate
  switch (action.type) {
    case actionTypes.AddRoomMessage:  //每次新消息来都会调用    
      // // 这里做了名称转换，方便以后名称修改，   之后只需修改这里即可
      // action.data.roomId = action.data.topic
      // action.data.text = action.data.content
      // action.data.content=undefined
      // action.data.messageId=action.data.serial
      if (state.get('messageList').has(action.data.roomId)) {
        let sshhh = state.get('messageList').get(action.data.roomId).toJS().find(mess => mess.messageId === action.data.messageId)
        if (sshhh) {
          console.log('接收到了重复的消息。')
          console.log(sshhh)
          return state
        }

        let newstate = state.merge({
          messageList: state.get('messageList').update(action.data.roomId, value => value.push(fromJS(action.data)))
        })
        // newstate = state.merge({
        //   messageList: messageList.get('messageList')
        //   // .update(action.data.roomId, value => {
        //   //   if(value.size > 10){
        //   //     return value.shift()
        //   //   }else{
        //   //     return value
        //   //   }
        //   // })
        // })
        // savemessageList(newstate.get('messageList'))
        return newstate
      } else {
        // state.get('messageList').set('2',[])
        // state.get('messageList').set('sd',[])
        // debugger
        let mseeagelist = state.get('messageList').toObject()
        mseeagelist[action.data.roomId] = [action.data]//为初始list添加第一个值
        // let sdsdfdsf={[action.data.roomId]:[action.data]}
        // let ss = fromJS(mseeagelist)
        // let s=fromJS(sdsdfdsf)
        newstate = state.merge({
          // messageList: state.get('messageList').set(action.data.roomId, fromJS([fromJS(action.data)]))
          messageList: fromJS(mseeagelist)

        })
        // savemessageList(newstate.get('messageList'))
        return newstate
      }
    case actionTypes.LoginOut:
      return state.merge({
        messageList: fromJS({})
      })
    case 'loadlocalstore':
      return state.merge({
        messageList: fromJS(action.data.messageList)
      })
    case actionTypes.OnlineServiceList:
      let sindex = state.toJS()

      if (action.onlineServiceList) {
        if (action.onlineServiceList.map) {
          action.onlineServiceList.map((value, index) => {
            sindex.onlineServiceList.push(value)
          })
        } else {
          let cindex = action.onlineServiceList
          sindex.onlineServiceList.push(cindex)
        }
        return fromJS(sindex)
      }
      break;
    case actionTypes.OnlineServiceId:
      console.log(action)
      console.log(state.toJS())
      let index = state.toJS()
      index.onlineServiceId = action.onlineServiceId
      console.log(index)
      return fromJS(index)
  }

  return state
}
